import React from 'react';

import StageChecklistItem from './StageChecklistItem';

export interface IStageChecklist {
    list: { displayName: string }[];
    current: number;
}

const StageChecklist = (props: IStageChecklist) => {
    return (
        <div>
            {props.list.map((item: { displayName: string }, index: number) => {
                return (
                    <StageChecklistItem
                        displayName={item.displayName}
                        index={index}
                        state={index > props.current ? 'incomplete' : index === props.current ? 'current' : 'done'}
                    />
                );
            })}
        </div>
    );
};

export default StageChecklist;
